interface Props {
  text?: string;
  /** Wrap in full-screen container — use when outside any layout */
  fullPage?: boolean;
  /** "dark" = admin/portal bg, "light" = public page bg. Default: dark */
  theme?: "dark" | "light";
}

export default function LoadingState({
  text,
  fullPage = false,
  theme = "dark",
}: Props) {
  const bgClass   = theme === "light" ? "bg-white"      : "bg-[#f3f7fb]";
  const spinColor = theme === "light" ? "border-[#2563eb]" : "border-[#2563eb]";
  const textColor = theme === "light" ? "text-[#0f172a]/40" : "text-slate-500/60";

  const inner = (
    <div className="flex flex-col items-center justify-center gap-4 py-24">
      <div
        className={`w-8 h-8 rounded-full border-2 border-t-transparent animate-spin ${spinColor}`}
      />
      {text && <p className={`text-sm ${textColor}`}>{text}</p>}
    </div>
  );

  if (fullPage) {
    return (
      <div className={`min-h-screen ${bgClass} flex items-center justify-center`}>
        <div className="flex flex-col items-center gap-4">
          <div
            className={`w-8 h-8 rounded-full border-2 border-t-transparent animate-spin ${spinColor}`}
          />
          {text && <p className={`text-sm ${textColor}`}>{text}</p>}
        </div>
      </div>
    );
  }

  return inner;
}
